import React from 'react';
import ReactDOM from 'react-dom';
import { connect } from 'react-redux'
import {
    ajaxChatFeedbackSearch,
    setChatQuery,
    setSearchTimerInterval,
    IncrementSearchTyping,
    setLoading,
    setQuery,
    convertTimeframeTitle,
    setFilterTimeframe,
    ajaxChatFilterV2
} from '../redux/FeedbackRedux';
import FormDropdown from './FormDropdown';
import Bar from "./Bar";
import { earliestCreatedAt, timeframeRangeText } from '../helpers/timeframeRange';
import TimeframeRangeLabel from '../TimeframeRangeLabel';

class ChatSearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchText: this.props.query
        };
        this.props.dispatch(ajaxChatFilterV2());
    }

    handleSearch() {
        this.props.dispatch(setLoading({ loading: true, location: 'search' }));
        window.localStorage.setItem('chat_search', $('input.feedback-search').val());
        this.props.dispatch(setQuery($('input.feedback-search').val()));
        this.props.dispatch(ajaxChatFilterV2());
    }

    dispatchTimeframe() {
        let timeframe = $(event.target).attr("id");
        window.localStorage.setItem('chat_timeframe', timeframe);
        this.props.dispatch(setLoading({ loading: true, location: 'search' }));
        this.props.dispatch(setFilterTimeframe(timeframe));
        this.props.dispatch(ajaxChatFilterV2());
    }

    handleChange() {
        this.setState({ searchText: this.refs.searchInput.value });
    }

    componentDidMount() {
        window.search_timer_started = false;
    }

    render() {
        return (
            <div className="col-md-12">
                <Bar>
                    <form className="w-100 d-flex roboto feedback-search position-relative align-items-center" onSubmit={(e) => {
                        e.preventDefault();
                        this.handleSearch();
                    }}>
                        <input
                            className="w-100 roboto feedback-search w-100 second-input input-primary"
                            type="text"
                            placeholder={__('Search Chats')}
                            defaultValue={this.state.searchText} onChange={this.handleChange.bind(this)} ref="searchInput"
                        />
                        {this.state.searchText !== "" && <span className='position-absolute cursor-pointer' onClick={() => {
                            this.setState({ ...this.state, searchText: '' });
                            $('input.feedback-search').val('');
                            this.handleSearch();
                        }} style={{ right: '35px' }}>x</span>}
                    </form>
                    <span type="button" className="btn btn-primary searchbar-button mr-2 position-relative" onClick={this.handleSearch.bind(this)}>{__('Search')}</span>

                    <FormDropdown
                        title={convertTimeframeTitle(this.props.timeframe)}
                        items={
                            [
                                { text: __('Today'), id: "today" },
                                { text: __('Yesterday'), id: "yesterday" },
                                { text: __('Week to Date'), id: "weekToDate" },
                                { text: __('Month to Date'), id: "monthToDate" },
                                { text: __('Last 30 Days'), id: "last30" },
                                { text: __('Lifetime'), id: "lifetime" },
                                { text: __('Custom'), id: "custom" }
                            ].map(item => ({
                                ...item,
                                range: timeframeRangeText(
                                    item.id,
                                    this.props.business?.call_at_timezone
                                        ?? (Array.isArray(this.props.businesses) ? this.props.businesses[0]?.call_at_timezone : undefined),
                                    this.props.business?.created_at ?? earliestCreatedAt(this.props.businesses)
                                )
                            }))
                        }
                        classes={"mr-2 roboto"}
                        buttonClasses={"roboto"}
                        itemOnClickFunction={this.dispatchTimeframe.bind(this)}
                    />
                    <div className="d-flex align-items-center">
                        <TimeframeRangeLabel
                            timeframe={this.props.timeframe}
                            timezone={this.props.business?.call_at_timezone
                                ?? (Array.isArray(this.props.businesses) ? this.props.businesses[0]?.call_at_timezone : undefined)}
                            lifetimeStart={this.props.business?.created_at ?? earliestCreatedAt(this.props.businesses)}
                        />
                    </div>
                </Bar>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        totals: state.totals,
        archive: state.archive,
        department_ids: state.department_ids ?? null,
        other_filter: state.other_filter,
        total: state.total_pages,
        status: state.status,
        query: state.query,
        timeframe: state.timeframe,
        feedback_id: (state.selected_feedback ?? null),
        business: (state.business ?? null),
        businesses: (state.businesses ?? null),
        business_id: (state.business ? state.business.business_id : (state.feedback_detail ? state.feedback_detail.business_id : null)),
        timer: state.search_typing_timer,
        search: state.query
    }
}

export default connect(mapStateToProps)(ChatSearchBar)
